import React from 'react';
import { Box, Link, Stack } from '@mui/material';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import { ChatAsset } from '../../models/Chat';
import { ChatOpenInNewTabLink } from './ChatAssetAttachment';

interface ChatLinkAttachmentProps {
  asset: ChatAsset;
  mt?: number;
}

const ChatLinkAttachment: React.FC<ChatLinkAttachmentProps> = ({ asset, mt = 0 }) => {
  return (
    <Box
      sx={{
        mt,
        maxWidth: { xs: '100%', sm: 560, md: 720 },
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{
          px: 1.25,
          py: 0.75,
          borderRadius: 1,
          border: 1,
          borderColor: 'divider',
          bgcolor: 'rgba(255,255,255,0.04)',
        }}
      >
        <LinkRoundedIcon sx={{ fontSize: 20, color: 'primary.light', flexShrink: 0 }} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Link
            href={asset.url}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            variant="body2"
            sx={{ fontWeight: 600, display: 'block', wordBreak: 'break-all' }}
          >
            {asset.title || asset.url}
          </Link>
          <ChatOpenInNewTabLink url={asset.url} compact />
        </Box>
      </Stack>
    </Box>
  );
};

export default ChatLinkAttachment;
